import React from 'react';

import '../../App.css';
import ZoomMtgEmbedded from '@zoomus/websdk/embedded';

function Meeting() {
  const client = ZoomMtgEmbedded.createClient();

  var authEndpoint = 'http://localhost:4000';
  var sdkKey = 'vUk4wK8cRJSaRIgJTdMUFg';
  var meetingNumber = '72740401185';
  var passWord = 'F1jsZz';
  var role = 0;
  var userName = 'React';
  var userEmail = '';
  var registrantToken = '';
  var zakToken = '';

  function getSignature(e) {
    e.preventDefault();

    fetch(authEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        meetingNumber: meetingNumber,
        role: role,
      }),
    })
      .then((res) => res.json())
      .then((response) => {
        startMeeting(response.signature);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function startMeeting(signature) {
    let meetingSDKElement = document.getElementById('meetingSDKElement');

    client.init({
      debug: true,
      zoomAppRoot: meetingSDKElement,
      language: 'en-US',
      customize: {
        meetingInfo: [
          'topic',
          'host',
          'mn',
          'pwd',
          'telPwd',
          'invite',
          'participant',
          'dc',
          'enctype',
        ],
        toolbar: {
          buttons: [
            {
              text: 'Custom Button',
              className: 'CustomButton',
              onClick: () => {
                console.log('custom button');
              },
            },
          ],
        },
      },
    });

    client.join({
      signature: signature,
      sdkKey: sdkKey,
      meetingNumber: meetingNumber,
      password: passWord,
      userName: userName,
      userEmail: userEmail,
      tk: registrantToken,
      zak: zakToken,
    });
  }

  return (
    <div className='App'>
      <main>
        <h1>Live Class</h1>

        {/* For Component View */}

        <button onClick={getSignature}>Join Meeting</button>
        <div id='meetingSDKElement' style={{ width: '100%', height: '100%' }}>
          {/* Zoom Meeting SDK Component View Rendered Here */}
        </div>
      </main>
    </div>
  );
}

export default Meeting;
